// BRAND-06: Vorschau-Modus-Banner — sichtbar wenn x-tenant-preview=1 Meta-Tag gesetzt

import { readMeta } from "../../lib/tenant-branding";

export default function PreviewBanner() {
  const isPreview = readMeta("x-tenant-preview") === "1";
  if (!isPreview) return null;

  return (
    <div
      role="status"
      className="bg-neko-orange text-neko-dark py-1 text-xs text-center font-medium"
    >
      Vorschau-Modus — nicht öffentlich
    </div>
  );
}
